import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPendoConfiguration } from '../domain/pendo.entity';
import { IUserPendoInfo } from './auth.service';
@Injectable({
  providedIn: 'root',
})
export class PendoCofigurationService {
  apiUrl = environment.apiBaseUrl + 'pendo/';

  constructor(private httpClient: HttpClient) {
  }

  getPendoConfiguration(): Observable<IPendoConfiguration> {
    return this.httpClient.get<IPendoConfiguration>(this.apiUrl + 'configuration');
  }

  getUserPendoInfo(): Observable<IUserPendoInfo> {
    const ret = this.httpClient.get<IUserPendoInfo>(
      this.apiUrl + 'userinfo',
      this.getOptions()
    );
    return ret;
  }

  getOptions() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return { headers };
  }
}
